import { graphql, useStaticQuery } from 'gatsby';
import { ProductVariants } from 'utils/types';

const getProductVariants = (allSpreeProduct: any) => {
  const variantMap = {};
  // combine variant map with new response data
  const combinedMap = Object.assign(
    variantMap,
    allSpreeProduct?.nodes?.reduce((acc: any, product: any) => {
      const masterVariant = product.variants.find((v: any) => v.is_master);
      const subscriptionVariants = product.variants
        .filter((v: any) => !v.is_master && v.subscription_plan)
        .map((item: any) => ({
          ...item,
          id: Number(item?.id),
          subscription_plan: {
            ...item?.subscription_plan,
            id: Number(item?.subscription_plan?.id),
          },
        }));

      /**
       * 90 is ID of the main Covid Product that we get back from the call to /v1/products.json above.
       * The product ID of the DTC Covid tests that we actually sell are 96 and 105 (fulgent and Assurance), which is the ID under which the reviews are stored.
       * For this reason, we need to use that ProductID here to get review data, as well as use that ID in the ReviwesContainer to open the widget with the Product ID that has reviews.
       * TODO: this will be simplified with this ticket: https://everlywell.atlassian.net/browse/EWD-11073
       */
      const COVID_PCR_PRODUCT_ID_WITH_REVIEWS = 96;
      const COVID_PCR_DTC_PRODUCT_ID = 90;

      const isCovidPcrDtc =
        product.productId === COVID_PCR_PRODUCT_ID_WITH_REVIEWS ||
        product.productId === COVID_PCR_DTC_PRODUCT_ID;
      const productId = !isCovidPcrDtc
        ? product.productId
        : COVID_PCR_DTC_PRODUCT_ID;

      acc[productId] = {
        price: masterVariant.price,
        name: product.name,
        slug: product.slug,
        canonicalUrl: product.canonicalUrl,
        variantId: Number(masterVariant.id),
        sku: masterVariant.sku,
        subscriptionVariants,
        metaDescription: product.meta_description,
        metaTitle: product.meta_title,
        metaKeywords: product.meta_keywords,
        promotionable: product.promotionable,
        maxQuantity: product.max_dtc_quantity,
      };
      return acc;
    }, {}),
  );

  return combinedMap;
};

const useProductVariants = (): ProductVariants => {
  const { allSpreeProduct } = useStaticQuery(graphql`
    query {
      allSpreeProduct {
        nodes {
          sku
          variants {
            is_master
            subscription_plan {
              id
              name
              percent_discount
            }
            id
            price
            sku
            total_on_hand
            price_in_dollars
          }
          id
          meta_description
          master_variant_id
          lowest_subscription_price
          taxons {
            name
            position
            taxonomy_id
            taxonomy_name
          }
          meta_title
          meta_keywords
          promotionable
          max_dtc_quantity
          slug
          productId
          name
        }
      }
    }
  `);

  const productVariants = getProductVariants(allSpreeProduct);
  return productVariants;
};
export default useProductVariants;
